import type { TabsProps } from 'antd';
import { Breadcrumb, Button, Card, Col, Row, Space, Tabs, Typography } from 'antd';
import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { RootState, i18n, useAppSelector } from '../../../common';
import {
  AddIcon,
  Guard,
  GuardFunction,
  SalesOpportunitiesTable,
  allSalesOpportunitiesTableColumns,
  allSalesOpportunitiesTableFilters,
} from '../../../components';
import { AppRoutes } from '../_router/app.routes';

const { Title } = Typography;

const SalesOpportunitiesPage = () => {
  const navigate = useNavigate();

  const currentUser = useAppSelector((state: RootState) => state.auth.user);

  const renderMySalesOpportunities = (): JSX.Element => (
    <SalesOpportunitiesTable
      columns={allSalesOpportunitiesTableColumns.filter((c) => c !== 'users' && c !== 'actions')}
      injectedQueryParams={{ filters: [{ name: 'users.id', operator: 'EQ', value: currentUser!.id!.toString() }], sorters: [{ columnKey: 'upcomingActivity', order: 'ascend' }, { columnKey: 'id', order: 'descend' }] }}
      filters={allSalesOpportunitiesTableFilters.filter((f) => f !== 'user')}
    />
  );

  const renderAllSalesOpportunities = (): JSX.Element => (
    <SalesOpportunitiesTable injectedQueryParams={{ sorters: [{ columnKey: 'upcomingActivity', order: 'ascend' }, { columnKey: 'id', order: 'descend' }] }} />
  );

  const tabs: TabsProps['items'] = [
    {
      key: '1',
      label: i18n.t('pages.salesOpportunities.mySalesOpportunities'),
      children: renderMySalesOpportunities(),
    },
    {
      key: '2',
      label: i18n.t('pages.salesOpportunities.allSalesOpportunities'),
      children: renderAllSalesOpportunities(),
    },
  ];

  const renderContent = (): JSX.Element => {
    if (GuardFunction({ domain: 'sales_opportunity', action: 'view_all_any' })) return <Tabs items={tabs} destroyInactiveTabPane={true}></Tabs>;
    return renderMySalesOpportunities();
  };

  return (
    <>
      <Breadcrumb
        items={[
          {
            title: (
              <Link to={AppRoutes.DASHBOARD.fullPath} key={AppRoutes.DASHBOARD.fullPath}>
                {i18n.t('breadcrumb.homepage')}
              </Link>
            ),
          },
          { title: i18n.t('breadcrumb.salesOpportunities') },
        ]}
        style={{ marginBottom: 24 }}
      />
      <Card>
        <Space direction="vertical" size={16} style={{ display: 'flex' }}>
          <Row justify={'space-between'} align={'middle'}>
            <Col>
              <Title level={2} style={{ margin: 0 }}>
                {i18n.t('pages.salesOpportunities.title')}
              </Title>
            </Col>
            <Col>
              <Guard permission={{ domain: 'sales_opportunity', action: 'create' }}>
                <Button
                  type="primary"
                  icon={<AddIcon />}
                  onClick={() => {
                    navigate(`${AppRoutes.SALES_OPPORTUNITIES.fullPath}/new`);
                  }}
                >
                  {i18n.t('components.forms.salesOpportunity.create')}
                </Button>
              </Guard>
            </Col>
          </Row>
          {renderContent()}
        </Space>
      </Card>
    </>
  );
};

export default SalesOpportunitiesPage;
